<template lang="pug">
.update_ctn
    .center
        img(src="../assets/update.png")
        div(style="color: #333;font-size: 16px;") 抱歉，系统正在升级～
        div(style="color: #959595;") 如有疑问请联系管理员
</template>

<script>
export default {
    name: 'update'
}
</script>

<style lang="sass" scoped>
.update_ctn
    height: 100%
    text-align: center
    position: relative
    line-height: 50px
    .center
        position: absolute
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        img
            width: 320px
</style>
